<div class="animated fadeIn fill-height-box-chat-v2"
  style="margin : 60px !important; padding-left: 0px !important; padding-right: 0px !important; background-color: white;">
  <ng-scrollbar #scrollbarForm appearance="compact" [autoHeightDisabled]="true" style="width: 100% !important;"
    [autoWidthDisabled]="true" [sensorDisabled]="false">
    <div class="container-fluid" style="background-color: white; padding: 0px;">

      <!-- List -->
      <div class="container p-4 content-space-1">
        <!-- Subscribe -->
        <div class="overflow-hidden">
          <div class="container content-space-1">
            <div class="position-relative bg-soft-primary rounded-3 p-7">
              <div class="row justify-content-lg-between align-items-lg-center">
                <div class="col-lg-5 mb-3 mb-lg-0">
                  <h2>Tell us what you are looking for: eg how to add user, how to upload leads...</h2>
                </div>
                <!-- End Col -->

                <div class="col-lg-7">
                  <form>
                    <!-- Input Card -->
                    <div class="input-card input-card-sm mb-3">
                      <div class="input-card-form" [formGroup]="searchForm_activity">
                        <input type="email" class="form-control form-control-lg" id="subscribeFormEg1"
                          (keydown.enter)="onEnter()" [(ngModel)]="searchValue" placeholder="Type Your Query"
                          aria-label="Search Query" formControlName="search_activity">
                        </div>
                        @if (searchForm_activity.get('search_activity').value == null || searchForm_activity.get('search_activity').value == '' || !searchHasRun) {
                          <button type="button"
                          class="btn btn-primary btn-lg" id="heroNameAddOnEg1" (click)="onEnter()">Find</button>
                        }
                        @if (!(searchForm_activity.get('search_activity').value == null || searchForm_activity.get('search_activity').value == '' || !searchHasRun)) {
                          <button type="button"
                            class="btn btn-danger btn-lg" id="heroNameAddOnEg1"
                          (click)="clearActivitySearchField(true)">Clear</button>
                        }
                      </div>
                      <!-- End Input Card -->
                    </form>
                  </div>
                  <!-- End Col -->
                </div>
                <!-- End Row -->
                <h2 style="color: red;">IMPORTANT!!! All queries/support must go via Support Chat Channel only — no direct calls or WhatsApp.!!! Write in detail with supporting screenshot or screen recording first,
                Strictly avoid direct call or whatsapp.</h2>
              </div>
              <h4 (click)="openSupportChat()" style="float: right; cursor: pointer; color: green; font-style: italic;"><i class="bi bi-chat-left-fill"></i>&nbsp;&nbsp;Click here to Reach
            out over Chat Support Channel</h4>
          </div>
        </div>

        @if (showSuggestion && suggestionText && searchHasRun) {
          <div class="comment-box mx-3">
            <h2 class="mb-0" (click)="suggestedSearch(suggestionText)" style="cursor: pointer; color:red;">Could Not
            Understand you. Did you mean : {{suggestionText}}</h2>
          </div>
        }

        @if (callingApi) {
          <div class="row">
            <div class="col-12">
              <div class="d-flex flex-column">
                <ngx-skeleton-loader count="3" [theme]="{ 'border-radius': '0', height: '5vh' }"></ngx-skeleton-loader>
              </div>
            </div>
          </div>
        }

        <!-- Card -->
        @if (action && actionDetail && actionDetail.length > 0) {
          @for (item of actionDetail; track item) {
            <div class="card card-flush card-stretched-vertical">
              <div class="row">
                @if (item.webVideoLink) {
                  <div class="col-sm-7">
                    <iframe width="640" height="360" [src]="item.webVideoLink" frameborder="0" webkitallowfullscreen
                    mozallowfullscreen allowfullscreen></iframe>
                  </div>
                }
                <div class="col-sm-5">
                  <div class="card-body">
                    <div class="mb-2">
                      <a class="card-link" (click)="takeAction(item.subAction)"
                      style="cursor: pointer;">{{item.clickAction}}</a>
                    </div>
                    <h3 class="card-title">
                      @if (item.instructionWeb) {
                        <a class="text-dark">How to Do On Webapp : {{item.instructionWeb}}</a>
                      }
                    </h3>
                  </div>
                </div>
              </div>
              @if (item.appVideoLink) {
                <div class="row">
                  <div class="col-sm-7">
                    <iframe width="640" height="360" [src]="item.appVideoLink" frameborder="0" webkitallowfullscreen
                    mozallowfullscreen allowfullscreen></iframe>
                  </div>
                  <div class="col-sm-5">
                    <div class="card-body">
                      <div class="mb-2">
                        <a class="card-link" style="cursor: pointer;">Instruction for App</a>
                      </div>
                      <h3 class="card-title">
                        @if (item.instructionApp) {
                          <a class="text-dark">How to Do On App : {{item.instructionApp}}</a>
                        }
                      </h3>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        }

        <!-- End Row -->
      </div>
      <!-- End List -->

    </div>
  </ng-scrollbar>
</div>